// src/locales/ta/packingBatch.js
export const packingBatch = {
  qtyPlaceholder: "அளவு",
  // Page Titles
  createPackingBatch: "பேக்கிங் தொகுப்பை உருவாக்கவும்",
  allPackingBatches: "பேக்கிங் தொகுப்புகள்",
  packingBatchDetails: "பேக்கிங் தொகுப்பு விவரங்கள்",
  createDescription: "கிடங்கு செயலாக்கத்திற்காக புதிய பேக்கிங் தொகுப்பை உருவாக்கவும்",

  // List Page
  pageDescription: "அனைத்து பேக்கிங் தொகுப்புகளையும் பார்த்து நிர்வகிக்கவும்",
  allCourierAccounts: "அனைத்து கூரியர் கணக்குகள்",
  allStatuses: "அனைத்து நிலைகள்",
  dateRange: "தேதி வரம்பு",
  searchByBatchNumber: "தொகுப்பு எண்ணால் தேடவும்...",
  noBatchesFound: "தொகுப்புகள் கிடைக்கவில்லை",
  noBatchesFoundDescription: "உங்கள் தேடல் அளவுகோல்களுடன் எந்த தொகுப்பும் பொருந்தவில்லை",
  failedToLoadBatches: "பேக்கிங் தொகுப்புகளை ஏற்ற முடியவில்லை",
  
  // Confirmations
  confirmRetryFailed: "தொகுப்பு {{batchNumber}} இல் தோல்வியுற்ற அனைத்து ஆர்டர்களையும் மீண்டும் முயற்சிக்க விரும்புகிறீர்களா?",
  confirmBulkRetry: "{{count}} தொகுப்பு(கள்) இல் தோல்வியுற்ற ஆர்டர்களை மீண்டும் முயற்சிக்கவா?",
  
  // Success/Error Messages
  retrySuccessCount: "{{count}} ஆர்டர்(கள்) வெற்றிகரமாக மீண்டும் முயற்சிக்கப்பட்டன",
  noOrdersRetried: "எந்த ஆர்டர்களும் வெற்றிகரமாக மீண்டும் முயற்சிக்கப்படவில்லை",
  noFailedBatchesSelected: "தோல்வியுற்ற ஆர்டர்களைக் கொண்ட தொகுப்புகள் தேர்ந்தெடுக்கப்படவில்லை",
  bulkRetrySuccessful: "{{count}} தொகுப்பு(கள்) இல் ஆர்டர்கள் வெற்றிகரமாக மீண்டும் முயற்சிக்கப்பட்டன",
  failedToRetrySome: "சில தொகுப்புகளை மீண்டும் முயற்சிக்க முடியவில்லை",
  retrySelected: "தேர்ந்தெடுத்ததை மீண்டும் முயற்சிக்கவும் ({{count}})",
  
  // Filters
  selectWarehouse: "கிடங்கைத் தேர்ந்தெடுக்கவும்",
  selectCourier: "கூரியர் சேவையைத் தேர்ந்தெடுக்கவும்",
  selectCourierAccount: "கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்",
  selectCourierRule: "கூரியர் ஒதுக்கீட்டு விதியைத் தேர்ந்தெடுக்கவும்",
  allOrders: "அனைத்து ஆர்டர்கள்",
  selectStatuses: "நிலைகளைத் தேர்ந்தெடுக்கவும்",
  allShops: "அனைத்து கடைகள்",
  allCities: "அனைத்து நகரங்கள்",
  allProducts: "அனைத்து பொருட்கள்",
  searchOrders: "ஆர்டர்களைத் தேடவும்",
  courierRule: "கூரியர் ஒதுக்கீட்டு விதி",
  courierAccount: "கூரியர் கணக்கு",
  warehouse: "கிடங்கு",
  orderStatus: "ஆர்டர் நிலை",
  products: "பொருட்கள்",
  advancedFilters: "மேம்பட்ட வடிகட்டிகள்",
  showAdvanced: "மேம்பட்ட வடிகட்டிகளைக் காட்டு",
  hideAdvanced: "மேம்பட்ட வடிகட்டிகளை மறை",
  searchPlaceholder: "ஆர்டர் எண், வாடிக்கையாளர் பெயர் அல்லது தொலைபேசி...",
  
  // Table Headers
  orderNumber: "ஆர்டர் எண்",
  order: "ஆர்டர்",
  customerName: "வாடிக்கையாளர்",
  customer: "வாடிக்கையாளர்",
  phoneNumber: "தொலைபேசி",
  shop: "கடை",
  city: "நகரம்",
  paymentType: "பணம் செலுத்தும் முறை",
  payment: "பணம் செலுத்துதல்",
  status: "நிலை",
  grandTotal: "மொத்தம்",
  total: "மொத்தம்",
  itemsPreview: "பொருட்கள்",
  items: "பொருட்கள்",
  airwaybillNumber: "ஏர்வேபில் எண்",
  
  // Batch Creation
  selectedOrders: "தேர்ந்தெடுக்கப்பட்ட ஆர்டர்கள்",
  selected: "தேர்ந்தெடுக்கப்பட்டது",
  totalValue: "மொத்த மதிப்பு",
  notes: "குறிப்புகள்",
  notesPlaceholder: "இந்த தொகுப்பு பற்றிய குறிப்புகளைச் சேர்க்கவும்...",
  createBatch: "பேக்கிங் தொகுப்பை உருவாக்கவும்",
  clearSelection: "தேர்வை அழி",
  account: "கணக்கு",
  
  // Progress
  creatingBatch: "பேக்கிங் தொகுப்பை உருவாக்குகிறது",
  processingOrder: "ஆர்டரைச் செயலாக்குகிறது",
  of: "இல்",
  processing: "செயலாக்குகிறது",
  success: "வெற்றி",
  failed: "தோல்வி",
  creating: "உருவாக்குகிறது...",
  searching: "தேடுகிறது...",
  retrying: "மீண்டும் முயற்சிக்கிறது...",
  adding: "சேர்க்கிறது...",
  
  // Results
  batchCreatedSuccessfully: "தொகுப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
  batchNumber: "தொகுப்பு எண்",
  batchNumberTitle: "தொகுப்பு எண் {{number}}",
  totalOrders: "மொத்த ஆர்டர்கள்",
  successfulOrders: "வெற்றிகரமானவை",
  failedOrders: "தோல்வியுற்றவை",
  viewBatchDetails: "தொகுப்பு விவரங்களைக் காண்க",
  createAnotherBatch: "மற்றொரு தொகுப்பை உருவாக்கவும்",
  printAirwaybills: "ஏர்வேபில்களை அச்சிடவும்",
  
  // Messages
  noEligibleOrders: "தகுதியான ஆர்டர்கள் கிடைக்கவில்லை",
  selectWarehouseFirst: "தயவுசெய்து கிடங்கைத் தேர்ந்தெடுக்கவும்",
  selectCourierFirst: "தயவுசெய்து கூரியர் நிறுவனத்தைத் தேர்ந்தெடுக்கவும்",
  selectAtLeastOneOrder: "தயவுசெய்து குறைந்தது ஒரு ஆர்டரையாவது தேர்ந்தெடுக்கவும்",
  batchCreationFailed: "பேக்கிங் தொகுப்பை உருவாக்க முடியவில்லை",
  searchFailed: "ஆர்டர்களைத் தேட முடியவில்லை",
  loadBatchError: "தொகுப்பு விவரங்களை ஏற்ற முடியவில்லை",
  noFailedOrders: "மீண்டும் முயற்சிக்க தோல்வியுற்ற ஆர்டர்கள் இல்லை",
  retryCompleted: "தோல்வியுற்ற ஆர்டர்கள் மீண்டும் முயற்சி முடிந்தது",
  retryError: "ஆர்டர்களை மீண்டும் முயற்சிக்க முடியவில்லை",
  searchOrdersError: "தகுதியான ஆர்டர்களைத் தேட முடியவில்லை",
  ordersAddedSuccess: "{{count}} ஆர்டர்(கள்) வெற்றிகரமாகச் சேர்க்கப்பட்டன",
  addOrdersError: "தொகுப்பில் ஆர்டர்களைச் சேர்க்க முடியவில்லை",
  largeBatchConfirm: "நீங்கள் {{count}} ஆர்டர்களைக் கொண்ட தொகுப்பை உருவாக்க உள்ளீர்கள். இதற்கு சிறிது நேரம் ஆகலாம். தொடரவா?",
  retryConfirm: "{{count}} தோல்வியுற்ற ஆர்டர்(களை) மீண்டும் முயற்சிக்கவா?",
  
  // Validation
  warehouseRequired: "கிடங்கு தேவை",
  courierRequired: "கூரியர் நிறுவனம் தேவை",
  ordersRequired: "குறைந்தது ஒரு ஆர்டர் தேவை",
  
  // Status
  inProgress: "முன்னேற்றத்தில்",
  completed: "முடிந்தது",
  partiallyFailed: "பகுதியளவு தோல்வி",
  statusCompleted: "முடிந்தது",
  statusInProgress: "முன்னேற்றத்தில்",
  statusPartiallyFailed: "பகுதியளவு தோல்வி",
  statusFailed: "தோல்வி",
  
  // Actions
  viewAllBatches: "அனைத்து தொகுப்புகளையும் காண்க",
  retryFailed: "தோல்வியுற்ற ஆர்டர்களை மீண்டும் முயற்சிக்கவும்",
  retryFailedOrders: "தோல்வியுற்ற ஆர்டர்களை மீண்டும் முயற்சிக்கவும்",
  retryAll: "அனைத்தையும் மீண்டும் முயற்சிக்கவும்",
  addOrders: "ஆர்டர்களைச் சேர்க்கவும்",
  viewOrder: "ஆர்டரைக் காண்க",
  copyAirwaybill: "ஏர்வேபிலை நகலெடுக்கவும்",
  
  // Batch Info
  createdBy: "உருவாக்கியவர்",
  createdAt: "உருவாக்கப்பட்ட தேதி",
  created: "உருவாக்கப்பட்டது",
  by: "மூலம்",
  batchStatus: "நிலை",
  
  // Empty States
  noBatchesYet: "இன்னும் தொகுப்புகள் இல்லை",
  createFirstBatch: "உங்கள் முதல் பேக்கிங் தொகுப்பை உருவாக்கவும்",
  noOrdersFound: "ஆர்டர்கள் கிடைக்கவில்லை",
  adjustFilters: "உங்கள் வடிகட்டிகளைச் சரிசெய்ய முயற்சிக்கவும்",
  noMatchingFilters: "உங்கள் தற்போதைய வடிகட்டிகளுடன் பொருந்தும் ஆர்டர்கள் இல்லை",
  eligibleOrders: "தகுதியான ஆர்டர்கள் ({{count}})",
  
  // Batch List
  batchManagement: "தொகுப்பு மேலாண்மை",
  filterByDate: "தேதியின்படி வடிகட்டவும்",
  filterByWarehouse: "கிடங்கின்படி வடிகட்டவும்",
  filterByCourier: "கூரியரின்படி வடிகட்டவும்",
  filterByStatus: "நிலையின்படி வடிகட்டவும்",
  searchByBatchNumber: "தொகுப்பு எண்ணால் தேடவும்",
  applyFilters: "வடிகட்டிகளைப் பயன்படுத்தவும்",
  resetFilters: "வடிகட்டிகளை மீட்டமைக்கவும்",
  
  // Statistics
  totalBatches: "மொத்த தொகுப்புகள்",
  totalOrdersProcessed: "மொத்த செயலாக்கப்பட்ட ஆர்டர்கள்",
  totalValueProcessed: "மொத்த செயலாக்கப்பட்ட மதிப்பு",
  successRate: "வெற்றி விகிதம்",
  
  // Batch Actions
  viewDetails: "விவரங்களைக் காண்க",
  exportBatch: "தொகுப்பை ஏற்றுமதி செய்க",
  printBatch: "தொகுப்பை அச்சிடவும்",
  backToBatches: "தொகுப்புகளுக்குத் திரும்பவும்",
  batchNotFound: "தொகுப்பு கிடைக்கவில்லை",
  loadingBatch: "தொகுப்பு விவரங்களை ஏற்றுகிறது...",
  
  // Batch Details
  ordersInBatch: "தொகுப்பில் ஆர்டர்கள் ({{count}})",
  searchOrdersPlaceholder: "ஆர்டர்களைத் தேடவும்...",
  allStatus: "அனைத்து நிலைகள்",
  showAll: "அனைத்தையும் காட்டு",
  failedOnly: "தோல்வியுற்றவை மட்டும்",
  addOrdersToBatch: "தொகுப்பில் ஆர்டர்களைச் சேர்க்கவும்",
  searchEligiblePrompt: "இந்த தொகுப்பில் சேர்க்க தகுதியான ஆர்டர்களைத் தேடவும்",
  addOrdersCount: "{{count}} ஆர்டர்(களை) சேர்க்கவும்",
  addingOrders: "தொகுப்பில் ஆர்டர்களைச் சேர்க்கிறது",
  selectPrintFormat: "அச்சு வடிவத்தைத் தேர்ந்தெடுக்கவும்",
  labelFormat: "102mm × 76mm லேபிள்",
  labelFormatDesc: "வெப்ப லேபிள் அச்சுப்பொறிகளுக்கு",
  a4Format: "A4 (ஒரு பக்கத்திற்கு 4)",
  a4FormatDesc: "நிலையான அலுவலக அச்சுப்பொறிகளுக்கு",
  
  // Counts/Formatting
  ordersCount: "{{count}} ஆர்டர்கள்",
  itemsCount: "{{count}} பொருட்கள்",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalQrDesc: "நீண்ட airwaybill எண்கள் உள்ள courier களுக்கு — முழு அகல barcode மற்றும் QR குறியீடு உட்பட",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",

  // Print Status
  printed: "அச்சிடப்பட்டது",
  notPrinted: "அச்சிடப்படவில்லை",
  printedAt: "அச்சிட்ட நேரம்",
  printedBy: "அச்சிட்டவர்",
  markPrintedError: "அச்சு நிலையை பதிவு செய்வதில் தோல்வி",

  // Product List View
  productListTitle: "பொருட்கள் பட்டியல் ({{count}})",
  viewOrdersTab: "ஆர்டர்கள்",
  viewProductsTab: "பொருட்கள்",
  searchProductsPlaceholder: "பொருட்களைத் தேடவும்...",
  productColumn: "பொருள்",
  skuColumn: "SKU",
  totalQuantityColumn: "மொத்த அளவு",
  orderCountColumn: "ஆர்டர்கள்",
  loadingProductList: "பொருட்கள் பட்டியல் ஏற்றப்படுகிறது...",
  noProductsFound: "பொருட்கள் எதுவும் இல்லை",
  noProductsFoundDescription: "உங்கள் தற்போதைய வடிகட்டிகளுக்கு பொருந்தும் பொருட்கள் இல்லை",
  loadProductListError: "பொருட்கள் பட்டியலை ஏற்ற முடியவில்லை",
  printProductList: "அச்சிடு",
  exportExcel: "Excel",
  exportPdf: "PDF",
  productListPrintSubtitle: "பொருட்கள் தொகுப்பு பட்டியல்",

  // Channel
  channel: "சேனல்",
  channelOnline: "ஆன்லைன்",
  channelOffline: "ஆஃப்லைன்",
  productListPrintTitle: "தயாரிப்பு பட்டியல் — தொகுப்பு #{{number}}",
  productListReceiptTitle: "தயாரிப்பு பட்டியல்",
  productListBatchLabel: "தொகுப்பு",
  productListPrintedOn: "அச்சிட்ட தேதி",
  receiptTotalProducts: "மொத்த தயாரிப்புகள்",
  receiptTotalQuantity: "மொத்த அளவு",
};

// Courier Upload Format translations
export const courierUpload = {
  // Page Titles
  title: "கூரியர் பதிவேற்ற வடிவ உருவாக்கி",
  pageTitle: "கூரியர் பதிவேற்ற வடிவ உருவாக்கி",
  subtitle: "அனுப்பப்பட்ட ஆர்டர்களுக்கு கூரியர்-குறிப்பிட்ட பதிவேற்ற கோப்புகளை உருவாக்கவும்",
  pageDescription: "அனுப்பப்பட்ட ஆர்டர்களுக்கு கூரியர்-குறிப்பிட்ட பதிவேற்ற கோப்புகளை உருவாக்கவும்",
  
  // Tabs
  byPackingBatch: "பேக்கிங் தொகுப்பின்படி",
  byDateCourier: "தேதி மற்றும் கூரியரின்படி",
  byDateAndCourier: "தேதி மற்றும் கூரியரின்படி",
  
  // Tooltips
  batchTooltip: "குறிப்பிட்ட பேக்கிங் தொகுப்பில் உள்ள அனைத்து ஆர்டர்களுக்கும் பதிவேற்ற கோப்பை உருவாக்கவும்",
  byPackingBatchTooltip: "குறிப்பிட்ட பேக்கிங் தொகுப்பில் உள்ள அனைத்து ஆர்டர்களுக்கும் பதிவேற்ற கோப்பை உருவாக்கவும்",
  dateTooltip: "கூரியருக்கு குறிப்பிட்ட தேதியில் அனுப்பப்பட்ட ஆர்டர்களுக்கு பதிவேற்ற கோப்பை உருவாக்கவும்",
  byDateAndCourierTooltip: "கூரியருக்கு குறிப்பிட்ட தேதியில் அனுப்பப்பட்ட ஆர்டர்களுக்கு பதிவேற்ற கோப்பை உருவாக்கவும்",
  
  // Filters
  selectPackingBatch: "பேக்கிங் தொகுப்பைத் தேர்ந்தெடுக்கவும்",
  selectCourierAccount: "கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்",
  dispatchedDate: "அனுப்பப்பட்ட தேதி",
  courierAccount: "கூரியர் கணக்கு",
  packingBatch: "பேக்கிங் தொகுப்பு",
  
  // Actions
  generatePreview: "முன்னோட்டத்தை உருவாக்கவும்",
  generating: "உருவாக்குகிறது...",
  clear: "அழி",
  viewPdf: "PDF பார்க்க",
  downloadPdf: "PDF பதிவிறக்கவும்",
  pdfTitle: "அனுப்பப்பட்ட ஆர்டர்கள்",
  companyName: "நிறுவனத்தின் பெயர்",
  courierCompanyLabel: "கூரியர் நிறுவனம்",
  courierRepresentative: "கூரியர் பிரதிநிதி",
  dateLabel: "தேதி",
  timeLabel: "நேரம்",
  dispatchConfirmText: "பின்வரும் பார்சல்கள் அனுப்பப்பட்டு விநியோகத்திற்காக கூரியர் பிரதிநிதியிடம் ஒப்படைக்கப்பட்டதை உறுதிப்படுத்துகிறோம்.",
  totalParcels: "மொத்த பார்சல்கள்",
  totalCodAmount: "மொத்த COD தொகை",
  dispatchConfirmation: "அனுப்புதல் உறுதிப்படுத்தல்",
  parcelCollectionConfirmation: "பார்சல் சேகரிப்பு உறுதிப்படுத்தல்",
  name: "பெயர்",
  signature: "கையொப்பம்",
  nameCourier: "பெயர் (கூரியர்)",
  signatureCourier: "கையொப்பம் (கூரியர்)",
  generatedOn: "உருவாக்கப்பட்டது",
  colNo: "#",
  colWaybill: "Waybill எண்",
  colOrderNo: "ஆர்டர் எண்",
  colCity: "நகரம்",
  colCod: "COD",
  pdfDownloadSuccess: "PDF வெற்றிகரமாக பதிவிறக்கப்பட்டது",
  pdfDataMissing: "PDF தரவு கிடைக்கவில்லை. backend சேவையகத்தை மீண்டும் தொடங்கி முன்னோட்டத்தை மீண்டும் உருவாக்கவும்.",
  pdfDownloadError: "PDF பதிவிறக்க முடியவில்லை",
  downloadExcel: "Excel பதிவிறக்கவும்",
  downloadCSV: "CSV பதிவிறக்கவும்",
  
  // Summary
  courierCompany: "கூரியர் நிறுவனம்",
  businessAccount: "வணிக கணக்கு",
  mappingFormat: "வரைபட வடிவம்",
  totalOrders: "மொத்த ஆர்டர்கள்",
  generatedAt: "உருவாக்கப்பட்ட நேரம்",
  
  // Preview
  dataPreview: "தரவு முன்னோட்டம்",
  showing: "காட்டுகிறது",
  showingRange: "{{total}} ஆர்டர்களில் {{from}} முதல் {{to}} வரை காட்டுகிறது",
  to: "முதல்",
  of: "இல்",
  orders: "ஆர்டர்கள்",
  ordersCount: "{{count}} ஆர்டர்கள்",
  page: "பக்கம்",
  previous: "முந்தைய",
  next: "அடுத்து",
  
  // Empty State
  noDataGenerated: "தரவு உருவாக்கப்படவில்லை",
  emptyStateMessage: "பதிவேற்ற வடிவத்தை உருவாக்க பேக்கிங் தொகுப்பு அல்லது கூரியர் கணக்கு மற்றும் தேதியைத் தேர்ந்தெடுக்கவும்",
  selectToGenerate: "பதிவேற்ற வடிவத்தை உருவாக்க பேக்கிங் தொகுப்பு அல்லது கூரியர் கணக்கு மற்றும் தேதியைத் தேர்ந்தெடுக்கவும்",
  
  // Messages
  selectBatchFirst: "தயவுசெய்து பேக்கிங் தொகுப்பைத் தேர்ந்தெடுக்கவும்",
  selectCourierDateFirst: "தயவுசெய்து கூரியர் கணக்கு மற்றும் தேதியைத் தேர்ந்தெடுக்கவும்",
  selectCourierAndDate: "தயவுசெய்து கூரியர் கணக்கு மற்றும் தேதியைத் தேர்ந்தெடுக்கவும்",
  excelDownloaded: "Excel கோப்பு வெற்றிகரமாக பதிவிறக்கப்பட்டது",
  excelDownloadSuccess: "Excel கோப்பு வெற்றிகரமாக பதிவிறக்கப்பட்டது",
  csvDownloaded: "CSV கோப்பு வெற்றிகரமாக பதிவிறக்கப்பட்டது",
  csvDownloadSuccess: "CSV கோப்பு வெற்றிகரமாக பதிவிறக்கப்பட்டது",
  failedToGenerate: "முன்னோட்டத்தை உருவாக்க முடியவில்லை",
  generateError: "முன்னோட்டத்தை உருவாக்க முடியவில்லை",
  failedToDownload: "கோப்பைப் பதிவிறக்க முடியவில்லை",
  excelDownloadError: "Excel கோப்பைப் பதிவிறக்க முடியவில்லை",
  csvDownloadError: "CSV கோப்பைப் பதிவிறக்க முடியவில்லை",
  loadRefDataFailed: "குறிப்பு தரவை ஏற்ற முடியவில்லை",
  
  // Additional fields
  ordersSheet: "ஆர்டர்கள்",
  batchOption: "தொகுப்பு எண் {{id}} - {{courier}} - {{date}} ({{orders}} ஆர்டர்கள்)",
  batchNumber: "தொகுப்பு எண் {{id}}",
};

// Dispatch translations
export const dispatch = {
  // Page Titles
  pageTitle: "ஆர்டர்களை அனுப்புதல்",
  pageDescription: "ஆர்டர்களை அனுப்ப பார்கோடை ஸ்கேன் செய்க",
  
  // Statistics
  todayDispatches: "இன்றைய அனுப்புதல்கள்",
  todayValue: "இன்றைய மதிப்பு",
  thisSession: "இந்த அமர்வு",
  
  // Scan Section
  scanToDispatch: "அனுப்ப ஸ்கேன் செய்க",
  orderIdentifier: "ஆர்டர் அடையாளங்காட்டி",
  identifierPlaceholder: "பார்கோடை ஸ்கேன் செய்க அல்லது ஆர்டர்/ஏர்வேபில் எண்ணை உள்ளிடவும்...",
  dispatchDate: "அனுப்பும் தேதி",
  pastDatesNotAllowed: "கடந்த தேதிகள் அனுமதிக்கப்படவில்லை",
  backdatedDispatch: "இது பின்தேதியிட்ட அனுப்புதல்",
  
  // Actions
  dispatchOrder: "ஆர்டரை அனுப்பவும்",
  processing: "செயலாக்குகிறது...",
  
  // Messages
  enterIdentifier: "தயவுசெய்து ஆர்டர் அடையாளங்காட்டியை உள்ளிடவும்",
  dispatchSuccess: "ஆர்டர் {orderNumber} வெற்றிகரமாக அனுப்பப்பட்டது",
  dispatchFailed: "அனுப்புதல் தோல்வியுற்றது",
  successfullyDispatched: "வெற்றிகரமாக அனுப்பப்பட்டது!",
  
  // Order Details
  orderNumber: "ஆர்டர் எண்",
  airwaybill: "ஏர்வேபில்",
  customer: "வாடிக்கையாளர்",
  status: "நிலை",
  totalAmount: "மொத்த தொகை",
  codAmount: "COD தொகை",
  location: "இடம்",
  phone: "தொலைபேசி",
  
  // Keyboard Shortcuts
  keyboardShortcuts: "விசைப்பலகை குறுக்குவழிகள்",
  focusInput: "உள்ளீட்டு புலத்தை கவனத்தில் கொள்ளவும்",
  submitScan: "ஸ்கேனைச் சமர்ப்பிக்கவும்",
  clearForm: "படிவத்தை அழிக்கவும்",
  
  // Recent Dispatches
  recentDispatches: "சமீபத்திய அனுப்புதல்கள்",
  noDispatchesYet: "இந்த அமர்வில் இன்னும் அனுப்புதல்கள் இல்லை",
  dispatchesWillAppear: "அனுப்பப்பட்ட ஆர்டர்கள் இங்கே தோன்றும்",
};

// Print translations
export const print = {
  pageTitle: "ஏர்வேபில்களை அச்சிடவும்",
  batchNumber: "தொகுப்பு எண் {{number}}",
  labelsCount: "{{count}} லேபிள்கள்",
  printLabels: "லேபிள்களை அச்சிடவும்",
  preparing: "தயாராகிறது...",
  format: "வடிவம்",
  warehouse: "கிடங்கு",
  courierAccount: "கூரியர் கணக்கு",
  readyToPrint: "அச்சிட தயார்",
  loadError: "அச்சு தரவை ஏற்ற முடியவில்லை",
  waitForLoad: "தயவுசெய்து பக்கம் முழுமையாக ஏற்றும் வரை காத்திருக்கவும்",
  invalidFormat: "தவறான அச்சு வடிவம்",
  formatNotSupported: "வடிவம் \"{{format}}\" ஆதரிக்கப்படவில்லை",
  loadingData: "அச்சு தரவை ஏற்றுகிறது...",
  preparingLabels: "{{count}} லேபிள்களை தயாராக்குகிறது",
  noDataAvailable: "அச்சு தரவு கிடைக்கவில்லை",
  unableToLoad: "இந்த தொகுப்பிற்கான அச்சு தரவை ஏற்ற முடியவில்லை",
  backToBatch: "தொகுப்புக்குத் திரும்பவும்",
  labelFormat: "102mm × 76mm லேபிள்",
  a4Format: "A4 (ஒரு பக்கத்திற்கு 4)",

  // Missing in dispatch section  
  dispatchBatch: "தொகுப்பை அனுப்பவும்",
  dispatching: "அனுப்புகிறது...",
  confirmDispatch: "{{count}} ஆர்டர்களை அனுப்பவும்",
  noOrdersToDispatch: "அனுப்ப ஆர்டர்கள் இல்லை",
  batchDispatchSuccess: "{{count}} ஆர்டர்கள் வெற்றிகரமாக அனுப்பப்பட்டன",
  dispatched: "அனுப்பப்பட்டது",
  dispatchedOrders: "அனுப்பப்பட்ட ஆர்டர்கள்",
  selectOrdersToDispatch: "அனுப்ப ஆர்டர்களைத் தேர்ந்தெடுக்கவும்",
  selectedOrdersCount: "{{total}} ஆர்டர்களில் {{selected}} தேர்ந்தெடுக்கப்பட்டன",
  sortBy: "Sort By",
  sortDoNotSort: "Do not Sort",
  sortItemsDisplay: "Items Display",
  sortOrderId: "Order ID",
  sortAirwaybillNumber: "Airwaybill Number",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalQrDesc: "நீண்ட airwaybill எண்கள் உள்ள courier களுக்கு — முழு அகல barcode மற்றும் QR குறியீடு உட்பட",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",
  markPrintedError: "அச்சு நிலையை பதிவு செய்வதில் தோல்வி",
};